export default "__VITE_ASSET__4FZu9EwU__"